
import { HeroSection } from "./HeroSection";
import { FeaturesSection } from "./FeaturesSection";
import { SecurityCompliance } from "./SecurityCompliance";
import { Footer } from "@/components/layout/Footer";
import { MainNavigation } from "@/components/layout/MainNavigation";

export const EnhancedLandingPage = () => {
  return (
    <>
      <MainNavigation />
      <main className="min-h-screen bg-background">
        <HeroSection />
        <FeaturesSection />
        <SecurityCompliance />
      </main>
      <Footer />
    </>
  );
};
